import { render, staticRenderFns } from "./DoKoDialogSpielergebnis.vue?vue&type=template&id=42a52412&scoped=true&"
import script from "./DoKoDialogSpielergebnis.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogSpielergebnis.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogSpielergebnis.vue?vue&type=style&index=0&id=42a52412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a52412",
  null
  
)

export default component.exports